import "@fontsource-variable/manrope"

import { extendTheme, theme as chakraTheme } from "@chakra-ui/react"

import { objectOmit } from "@supliful/common"

import { suplifulTheme } from "./config/suplifulTheme"

export { suplifulTheme } from "./config/suplifulTheme"
export { INTERCOM_Z_INDEX, IntercomZIndex } from "./global/IntercomZIndex"

type SuplifulTheme = typeof suplifulTheme

declare module "@emotion/react" {
  export interface Theme {
    colors: SuplifulTheme["colors"]
    breakpoints: SuplifulTheme["breakpoints"]
    fontSizes: SuplifulTheme["fontSizes"]
    fonts: SuplifulTheme["fonts"]
    space: SuplifulTheme["space"]
    shadows: SuplifulTheme["shadows"]
    borders: SuplifulTheme["borders"]
  }
}

export const theme = extendTheme(
  {
    ...suplifulTheme,
  },
  // Omit some properties from the default Chakra theme.
  // E.g, some color and fontSize properties.
  {
    ...chakraTheme,
    colors: objectOmit(chakraTheme.colors, [
      "facebook",
      "messenger",
      "whatsapp",
      "twitter",
      "telegram",
      "linkedin",
    ]),
    fontSizes: objectOmit(chakraTheme.fontSizes, ["9xl", "8xl", "7xl", "6xl"]),
  },
)
